import { render } from "./DownloadPerplexiti.vue?vue&type=template&id=65e96f7f"
import script from "./DownloadPerplexiti.vue?vue&type=script&lang=js"
export * from "./DownloadPerplexiti.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__